import React, { useContext, useState } from 'react'
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material';
import { RegionMasterEdit } from './RegionMasterEdit';
import { RegionDataType, useRegionMaster } from '../DataFetch/useRegionMaster';
import { SessionContext } from '../ManagementRoot';

export function RegionMaster() {

    const {regionMaster, mutate} = useRegionMaster();

    const [editing, setEditing] = useState<boolean>(false);

    const [editData, setEditData] = useState<RegionDataType | undefined>(undefined);

    const ConfirmSession = useContext(SessionContext);

    async function OpenEditor(data:RegionDataType | undefined) {

        if(!await ConfirmSession()) {
            return;
        }

        setEditData(data);
        setEditing(true);
    }

    function CompleteEdit() {
        setEditing(false);
        mutate();
    }

    function RegionList() {
        return(
            <>
                <TableContainer sx={{maxHeight:800}}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>地域ID</TableCell>
                                <TableCell>地域名</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {regionMaster?.map((item:RegionDataType, index:number) => (
                                <TableRow key={index} hover>
                                    <TableCell>{item.region_id}</TableCell>
                                    <TableCell>{item.region_name}</TableCell>
                                    <TableCell>
                                        <Button variant="contained" onClick={() => OpenEditor(item)}>編集</Button>
                                        {" "}
                                        {/* <Button variant="contained" color="error">削除</Button> */}
                                    </TableCell>
                                </TableRow>
                            ))} 
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box m={2} textAlign="left">
                    <Button variant="contained" onClick={() => OpenEditor(undefined)}>新規作成</Button>
                </Box>
            </>
        );
    }

    return(
        <>
            <Typography
                variant="h6"
            >
                地域マスタ
            </Typography>
            <Grid2 xs={12}>
                <Paper sx={{overflow:"hidden", whiteSpace:"nowrap"}}>
                    <Box m={2} p={1}>
                        {editing ? <RegionMasterEdit editData={editData} CompleteEdit={CompleteEdit} setEditing={setEditing}/> : <RegionList/>}
                    </Box>
                </Paper>
            </Grid2>
        </>
    );
}